var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"value":_vm.value,"placeholder":_vm.$tc('identificationType'),"filterable":"","clearable":""},on:{"change":_vm.onChange}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.id,attrs:{"label":`${item.identificationTypeName}`,"value":item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }